import { MouseEvent, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button, NewPagination, Table } from 'components'
import { GridHeader } from '../GridHeader'

import { BoxActions } from 'store/Box'
import { all as allBox } from 'store/Box/Box.selector'
import { all as allOrders } from 'store/Order/Order.selector'
import { all } from 'store/TraceabilityTables/TraceabilityTables.selector'

import { getColumnsByTheme } from 'constants/box-retail.constants'
import { INITIAL_STATE } from 'constants/traceability.constants'
import { useTranslation } from 'react-i18next'

import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import { ModalSendEmail } from 'components/ModalSendMail'
import { UserStorageService } from 'services'
import * as S from './styled'

export function BoxesList() {
  const { t } = useTranslation()
  const module = UserStorageService.getViewModuleTheme()

  const columns = getColumnsByTheme(module, UserStorageService.isAdmin())

  console.log(module)

  const dispatch = useDispatch()

  const [modalExport, setModalExport] = useState(false)
  const [filter, setFilter] = useState({ ...INITIAL_STATE })
  const { filters, tableLoading } = useSelector(all)
  const { filterBoxes, boxes = [] } = useSelector(allBox)
  const { ordersKeys } = useSelector(allOrders)

  const { pagination } = boxes
  const [isNewPage, setNewPage] = useState({ ...pagination })

  const fetch = useCallback(() => {
    setFilter(filters)
    if (!boxes.items) dispatch(BoxActions.getBoxes(filters, ordersKeys))
  }, [dispatch, filters, ordersKeys, boxes.items])

  useEffect(() => {
    if (ordersKeys.length) fetch()
  }, [fetch, ordersKeys])

  function changeColumn({ column, row }) {
    if (column.name === 'status') {
      return <p>{t(`common:${row.status}`)}</p>
    } else return row[column.name]
  }

  async function handleChangePage(
    event: MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) {
    const limit = boxes.pagination.limit
    const newFilter = {
      ...filterBoxes,
      ...filters
    }
    newFilter.page = newPage
    newFilter.limit = limit
    dispatch(BoxActions.setFilterBoxes(newFilter))
    dispatch(BoxActions.getBoxes(newFilter, ordersKeys))
  }

  function handleNewPage() {
    const newPage = isNewPage.page
    if (newPage > pagination.totalPages) {
      const newFilter = {
        ...filterBoxes,
        ...filters
      }
      const limit = boxes.pagination.limit
      newFilter.limit = limit
      newFilter.page = pagination.totalPages
      dispatch(BoxActions.setFilterBoxes(newFilter))
      dispatch(BoxActions.getBoxes(newFilter, ordersKeys))
      setNewPage({ ...pagination, page: newPage })
    } else {
      const newFilter = {
        ...filterBoxes,
        ...filters
      }
      const limit = boxes.pagination.limit
      newFilter.limit = limit
      newFilter.page = pagination.totalPages
      dispatch(BoxActions.setFilterBoxes(newFilter))
      dispatch(BoxActions.getBoxes(newFilter, ordersKeys))
      setNewPage({ ...pagination, page: newPage })
    }
  }

  function handleInputPagination(name: string, value: number) {
    setNewPage({ ...pagination, [name]: value })
  }

  function handleChangeRowsPerPage(e) {
    const newFilter = {
      ...filterBoxes,
      ...filters
    }
    newFilter.limit = Number(e.target.value)
    dispatch(BoxActions.setFilterBoxes(newFilter))
    dispatch(BoxActions.getBoxes(newFilter, ordersKeys))
  }

  function onExport() {
    setModalExport(true)
    dispatch(BoxActions.getBoxesExported(filters, ordersKeys))
  }

  return (
    <S.FullGrid item xs={12}>
      <S.HeaderContainer>
        {boxes.items?.length > 0 && (
          <GridHeader title={t('common:productList')} />
        )}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <p
            style={{
              fontSize: '1.4rem',
              color: 'gray',
              marginRight: '1.5rem'
            }}
          >
            {boxes?.pagination?.totalItems} {t('common:register')}
          </p>
          <Button variant="primary" size="medium" onClick={onExport}>
            <S.ButtonContent>
              <CloudDownloadIcon />
              <S.ButtonText>{t('common:export')}</S.ButtonText>
            </S.ButtonContent>
          </Button>
        </div>
      </S.HeaderContainer>
      <S.GridTable>
        <Table
          columns={columns}
          rows={boxes.items || []}
          sortColumn={{ column: filter.column, sort: filter.direction }}
          isLoading={tableLoading}
          changeColumn={changeColumn}
          isScroll={boxes.items?.length > 10}
        />
        {modalExport && (
          <ModalSendEmail
            title={t('modalExportOrders:titleItems')}
            description={t('modalExportOrders:message')}
            onExit={() => setModalExport(false)}
          />
        )}
        {pagination?.totalItems > 0 && (
          <NewPagination
            count={pagination?.totalPages}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            handleInput={handleInputPagination}
            handleNewPage={handleNewPage}
            page={pagination?.page}
            limit={pagination.limit}
          />
        )}
      </S.GridTable>
    </S.FullGrid>
  )
}
